import { useState } from 'react'
import { useTranslation } from 'react-i18next'

import { Button, Flex } from '@percent/lemonade'
import { ReactComponent as NothingHere } from '@percent/partner-dashboard/common/assets/images/nothing_here.svg'
import styles from './Security.module.scss'
import { useAuthState } from '@percent/partner-dashboard/common/hooks/useAuthState/useAuthState'
import { ChangeTwoFactorDeviceContainer } from './ChangeTwoFactorDevice/ChangeTwoFactorDeviceContainer'
import { DisableTwoFactorDeviceContainer } from './DisableTwoFactorDevice/DisableTwoFactorDeviceContainer'

export function Security() {
  const { t } = useTranslation()
  const [isChangeTwoFactorDeviceModalOpened, setIsChangeTwoFactorDeviceModalOpened] = useState(false)
  const [isDisableTwoFactorDeviceModalOpened, setIsDisableTwoFactorDeviceModalOpened] = useState(false)
  const { user } = useAuthState()
  const [checked, setChecked] = useState(!!user?.twoFaSecretVerifiedAt)

  return (
    <Flex direction="column" w="100%" p={16}>
      {user?.ssoUser ? (
        <div className={styles.infoContainer}>
          <div className={styles.nothingHere}>
            <NothingHere />
            <span className={styles.header}>{t('typography.nothingHere')}</span>
            <span className={styles.text}>{t('typography.ssoManagedProvider')}</span>
          </div>
        </div>
      ) : (
        <>
          <div className={styles.optionContainer}>
            <div className={styles.textContainer}>
              <p className={styles.text}>{t('typography.2faOption')}</p>
              <p className={styles.subtext}>{t('typography.2faSubtext')}</p>
            </div>
            <div className={styles.buttonContainer}>
              {checked && (
                <Button variant="secondary" onClick={() => setIsChangeTwoFactorDeviceModalOpened(true)}>
                  {t('button.change2faDevice')}
                </Button>
              )}
              {checked ? (
                <Button variant="secondary" onClick={() => setIsDisableTwoFactorDeviceModalOpened(true)}>
                  {t('button.disable2faShort')}
                </Button>
              ) : (
                <Button variant="primary" onClick={() => setIsChangeTwoFactorDeviceModalOpened(true)}>
                  {t('button.enable2fa')}
                </Button>
              )}
            </div>
          </div>
          <ChangeTwoFactorDeviceContainer
            isOpened={isChangeTwoFactorDeviceModalOpened}
            onClose={() => setIsChangeTwoFactorDeviceModalOpened(false)}
          />
          <DisableTwoFactorDeviceContainer
            isOpened={isDisableTwoFactorDeviceModalOpened}
            onClose={() => setIsDisableTwoFactorDeviceModalOpened(false)}
            setChecked={setChecked}
          />
        </>
      )}
    </Flex>
  )
}
